import { Injectable } from '@angular/core';
import { BookDataService } from '../data/book-service';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  forkJoin,
  of,
} from 'rxjs';
import { map, switchMap, first, mergeAll } from 'rxjs/operators';
import {
  BookGetModel,
  BookAddModel,
  BookPrice,
  BuyingLink
} from '../interfaces/interfaces';
import { PassDataService } from '../services/pass-data.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class BookLogicService {
  deleteId: string = '';
  deleteImagesName: string[] = [];

  constructor(
    private bookDataService: BookDataService,
    private passDataService: PassDataService
  ) { }

  getAllBooksLogic(): Observable<BookGetModel[]> {
    return this.bookDataService.getAllBooksData().pipe(
      switchMap((d) => {
        let books = [];
        for (let i = 0; i < d.length; i++) {
          let book = d[i] as BookGetModel;

          let bookModel = new BookGetModel(
            book._id,
            book.title,
            book.description,
            book.noOfPages,
            book.price,
            book.buyingLink,
            book.imageUrls
          );

          books.push(bookModel);
        }
        return [books];
      })
    );
  }

  async addBookLogic(
    title: string,
    description: string,
    noOfPages: string,
    price: BookPrice[],
    buyingLink: BuyingLink[],
    files: File[]
  ) {
    const imageLinks = await this.bookDataService.uploadBookImageData(files);
    return this.bookDataService.addBookData(
      new BookAddModel(
        title,
        description,
        noOfPages,
        price,
        buyingLink,
        imageLinks
      )
    )
  }

  async updateBookLogic(
    id: string,
    title: string,
    description: string,
    noOfPages: string,
    price: BookPrice[],
    buyingLink: BuyingLink[],
    files: any,
    imageUrls: string[]
  ) {

    let imageLinks: any[] = [];

    if (files.length !== 0) {
      imageLinks = await this.bookDataService.uploadBookImageData(files);
      //console.log("update ", imageLinks)
      imageUrls.push(...imageLinks)
      return this.bookDataService.updateBookData(
        new BookGetModel(
          id,
          title,
          description,
          noOfPages,
          price,
          buyingLink,
          imageUrls
        )
      )
    } else {
      return this.bookDataService.updateBookData(
        new BookGetModel(
          id,
          title,
          description,
          noOfPages,
          price,
          buyingLink,
          imageUrls
        )
      )
    }

  }

  async deleteBookLogic(data: any) {
    const resp = await this.bookDataService.deleteBookData(data?._id, data?.imageUrls);
    //console.log(resp)
    return resp
  }

  async deleteBookImageLogic(bookId: string, link: string, links: string[]) {
    const data = await this.bookDataService.deleteBookImageAndUpdate(bookId, link, links);
    if(data == "success") {
      const filter = links.filter(f => f !== link);
      await this.bookDataService.updateBookImageData(bookId, filter)
      return { message: "success", links: filter }
    } else {
      return "error"
    }
  }
}
